import Date from './Date.vue';

export default Date;



// WEBPACK FOOTER //
// ./src/pages/profile/components/info/components/date/index.ts